import router from './router'
// import { Message } from 'element-ui'
import axios from 'axios'
import Layout from '@/views/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入
const _import = require('./router/_import_' + process.env.NODE_ENV) //获取组件的方法
var getRouter //用来获取后台拿到的路由

// 假装fakeRouter是通过后台接口请求回来的数据
var fakeRouter2 = {
  "data": [
    {
      "path": "",
      "component": "Layout",
      "meta": {
        "title": "首页",
        "icon": "icon-shouye"
      },
      "children": [
        {
          "path": "index",
          "component": "dashboard/index",
          "meta": {
            "title": "首页",
            "icon": "icon-shouye"
          }
        }
      ]
    },
    {
      "path": "/projectManage",
      "component": "Layout",
      "meta": {
        "title": "项目管理",
        "icon": "icon-xiangmuguanli"
      },
      "children": [
        {
          "path": "itemsList",
          "name": "itemsList",
          "component": "projectManage/itemsList",
          "meta": {
            "title": "项目列表"
          }
        },
        {
          "path": "itemsList/add",
          "name": "itemsAdd",
          "component": "projectManage/itemsAdd",
          "meta": {
            "title": "项目新增"
          },
          "hidden": true
        },
        {
          "path": "itemsList/detail",
          "name": "itemsDetail",
          "component": "projectManage/itemsDetail",
          "meta": {
            "title": "项目详情"
          },
          "hidden": true
        },
        {
          "path": "contractList",
          "name": "contractList",
          "component": "projectManage/contractList",
          "meta": {
            "title": "合同列表"
          }
        },
        {
          "path": "contractList/add",
          "name": "contractListAdd",
          "component": "projectManage/contractListAdd",
          "meta": {
            "title": "合同新增"
          },
          "hidden": true
        }
      ]
    },
    {
      "path": "/businessManage",
      "component": "Layout",
      "meta": {
        "title": "业务管理",
        "icon": "icon-yewuguanli"
      },
      "children": [
        {
          "path": "dailyTasks",
          "name": "dailyTasks",
          "component": "businessManage/dailyTasks",
          "meta": {
            "title": "日常考评业务"
          }
        },
        {
          "path": "dailyTasks/detail",
          "name": "dailyTasksDetail",
          "component": "businessManage/dailyTasksDetail",
          "meta": {
            "title": "日常考评业务详情"
          },
          "hidden": true
        },
        {
          "path": "lookingBackBusiness",
          "name": "lookingBackBusiness",
          "component": "businessManage/lookingBackBusiness",
          "meta": {
            "title": "回头看业务"
          }
        },
        {
          "path": "lookingBackBusiness/detail",
          "name": "lookingBackBusinessDetail",
          "component": "businessManage/lookingBackBusinessDetail",
          "meta": {
            "title": "日常考评业务详情"
          },
          "hidden": true
        }
      ]
    },
    {
      "path": "/appraisalSet",
      "component": "Layout",
      "name": "appraisalSet",
      "meta": {
        "title": "考评配置",
        "icon": "icon-kaoping"
      },
      "children": [
        {
          "path": "taskSet",
          "name": "taskSet",
          "component": "appraisalSet/taskSet",
          "meta": {
            "title": "考评任务配置"
          }
        },
        {
          "path": "taskSet/add",
          "name": "taskSetAdd",
          "component": "appraisalSet/taskSetAdd",
          "meta": {
            "title": "添加考评任务"
          }
        },
        {
          "path": "planSet",
          "name": "planSet",
          "component": "appraisalSet/planSet",
          "meta": {
            "title": "考评计划配置"
          }
        },
        {
          "path": "planSet/add",
          "name": "planSetAdd",
          "component": "appraisalSet/planSetAdd",
          "meta": {
            "title": "添加考评计划"
          },
          "hidden": true
        },
        {
          "path": "planSet/detail",
          "name": "planSetDetail",
          "component": "appraisalSet/planSetDetail",
          "meta": {
            "title": "日常考评业务详情"
          },
          "hidden": true
        },
        {
          "path": "standardSet",
          "name": "standardSet",
          "component": "appraisalSet/standardSet",
          "meta": {
            "title": "考评标准配置"
          }
        },
        {
          "path": "standardSet/add",
          "name": "standardSetAdd",
          "component": "appraisalSet/standardSetAdd",
          "meta": {
            "title": "添加考评标准"
          },
          "hidden": true
        },
        {
          "path": "standardSet/detail",
          "name": "standardSetDetail",
          "component": "appraisalSet/standardSetDetail",
          "meta": {
            "title": "考评标准详情"
          },
          "hidden": true
        },
        {
          "path": "questionSet",
          "name": "questionSet",
          "component": "appraisalSet/questionSet",
          "meta": {
            "title": "问题选项配置"
          }
        }
      ]
    },
    {
      "path": "/dataStatistics",
      "component": "Layout",
      "name": "dataStatistics",
      "meta": {
        "title": "数据统计",
        "icon": "icon-shujutongji"
      },
      "children": [
        {
          "path": "planningStatistics",
          "name": "planningStatistics",
          "component": "dataStatistics/planningStatistics",
          "meta": {
            "title": "考评计划数据统计"
          }
        },
        {
          "path": "checkedStatistics",
          "name": "checkedStatistics",
          "component": "dataStatistics/checkedStatistics",
          "meta": {
            "title": "项目检查数据统计"
          }
        },
        {
          "path": "memberStatistics",
          "name": "memberStatistics",
          "component": "dataStatistics/memberStatistics",
          "meta": {
            "title": "检查人员数据统计"
          }
        },
        {
          "path": "questionStatistics",
          "name": "questionStatistics",
          "component": "dataStatistics/questionStatistics",
          "meta": {
            "title": "问题细则数据统计"
          }
        },{
          "path": "scoreStatistics",
          "name": "scoreStatistics",
          "component": "dataStatistics/scoreStatistics",
          "meta": {
            "title": "考评计划数据统计"
          }
        },{
          "path": "staticsOut",
          "name": "staticsOut",
          "component": "dataStatistics/staticsOut",
          "meta": {
            "title": "考评计划数据导出"
          }
        },{
          "path": "evaluationBack",
          "name": "evaluationBack",
          "component": "dataStatistics/evaluationBack",
          "meta": {
            "title": "回头看任务统计"
          }
        }
      ]
    },
    {
      "path": "/set",
      "component": "Layout",
      "name": "set",
      "meta": {
        "title": "系统设置",
        "icon": "icon-xitongshezhi"
      },
      "children": [
        {
          "path": "system",
          "name": "system",
          "component": "set/system",
          "meta": {
            "title": "系统管理"
          }
        },
        {
          "path": "role",
          "name": "role",
          "component": "set/role",
          "meta": {
            "title": "角色管理"
          }
        },
        {
          "path": "role/add",
          "name": "roleAdd",
          "component": "set/roleAdd",
          "meta": {
            "title": "添加角色"
          },
          "hidden": true
        },
        {
          "path": "member",
          "name": "member",
          "component": "set/member",
          "meta": {
            "title": "成员管理"
          }
        },
        {
          "path": "member/add",
          "name": "memberAdd",
          "component": "set/memberAdd",
          "meta": {
            "title": "添加成员"
          },
          "hidden": true
        },
        {
          "path": "member/detail",
          "name": "memberDetail",
          "component": "set/memberDetail",
          "meta": {
            "title": "成员详情"
          },
          "hidden": true
        }
      ]
    },
    {
      "path": "*",
      "redirect": "/404",
      "hidden": true
    }
  ]
}
var getRouter=false
localStorage.setItem('router', 'null')
router.beforeEach((to, from, next) => {
  let permissionUrl=JSON.parse(localStorage.getItem("permissionUrl"))
  permissionUrl=(permissionUrl===''||permissionUrl===undefined||permissionUrl===null)?[]:permissionUrl
  if (!getRouter) { //不加这个判断，路由会陷入死循环
    if (!getObjArr('router')) {
      // easy-mock官网经常挂掉，所以就不请求了,你们可以替换成自己公司的接口去请求,把下方的axios请求打开即可
      getRouter = fakeRouter2.data //假装模拟后台请求得到的路由数据
      saveObjArr('router', getRouter) //存储路由到localStorage
      routerGo(to, next) //执行路由跳转方法
    } else { //从localStorage拿到了路由
      getRouter = getObjArr('router') //拿到路由
      routerGo(to, next)
    }
  } else {
    if(isNull(localStorage.getItem("token"))){
      if(to.path==='/login'){
        next();
      }else{
        next('/login')
      }
    }else if(permissionUrl.indexOf(to.path)<0&&to.path!=='/login'){
      if(to.path==='/'&&!isNull(localStorage.getItem("IndexPage"))){
        if(to.path===localStorage.getItem("IndexPage")){
          next();
        }else{
          next(localStorage.getItem("IndexPage"))
        }
      }else{
        if(to.path==='/login'){
          next();
        }else{
          next();
          // next('/login')
        }
      }
    }else{
      next()
    }

  }
})

function isNull(data){
  return data===''||data===undefined||data===null
}


function routerGo(to, next) {
  getRouter = filterAsyncRouter(getRouter) //过滤路由
  router.addRoutes(getRouter) //动态添加路由
  global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  next({ ...to, replace: true })
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));
}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Layout') { //Layout组件特殊处理
        route.component = Layout
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/promission.js